import './style.css'

const Daanbg = () => {
  return (
   <div className="home-img-bg">
  <img src="/daanbg3.jpg" alt="" />
  <div className="text">
    <h1>Daan Hotels</h1>
  </div>
</div>
  )
}

export default Daanbg